// 引入路由模块并使用它
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [{
    path: '/',
    meta: {
      title: "在线表格"
    },
    component: () => import('../components/Home.vue'),
  }, {
    meta: {
      title: "报告文号"
    },
    path: '/report',
    component: () => import('../components/HelloReport.vue'),
  },
  {
    meta: {
      title: "询证函取号"
    },
    path: '/BANKCL',
    component: () => import('../components/BANKCL.vue'),
  },
  {
    meta: {
      title: "pdf在线预览"
    },
    path: '/PDF',
    component: () => import('../components/pdf.vue'),
  },
  {
    meta: {
      title: "日程安排"
    },
    path: '/FullCalendar',
    component: () => import('../components/FullCalendar.vue'),
  },
  {
    meta: {
      title: "信息查询"
    },
    path: '/qr',
    component: () => import('../components/qr.vue'),
  },
  {
    meta: {
      title: "发票审批"
    },
    path: '/invoice/pedding',
    component: () => import('../components/InvoPedding.vue'),
  },
  {
    meta: {
      title: "快递寄送"
    },
    name: 'Express',
    path: '/express',
    component: () => import('../components/express.vue'),
  },
  {
    meta: {
      title: "申请快递寄送"
    },
    name: 'NewExpress',
    path: '/express/new',
    component: () => import('../components/components/NewExpress.vue')
  },
  {
    meta: {
      title: "扫码"
    },
    name: 'ScanIndex',
    path: '/scan',
    component: () => import('../components/scanIndex.vue')
  },
  {
    meta: {
      title: "h5扫码"
    },
    name: 'htmlQR',
    path: '/htmlQR',
    component: () => import('../components/htmlQr.vue')
  },
  {
    meta: {
      title: "签收快递"
    },
    name: 'expSign',
    path: '/expSign',
    component: () => import('../components/expsign.vue')
  },
  {
    meta: {
      title: "快递寄送审批"
    },
    name: 'InExpress',
    path: '/express/in',
    component: () => import('../components/components/inExpress.vue')
  },
  {
    meta: {
      title: "申请发票"
    },
    name: 'NewInvoice',
    path: '/invoice/new',
    component: () => import('../components/components/NewInvoice.vue')
  },
  {
    meta: {
      title: "发票清单"
    },
    name: 'InvoiceList',
    path: '/invoice/list',
    component: () => import('../components/components/InvoiceList.vue')
  }
    // {
    //   meta: {
    //     title: "请假报备"
    //   },
    //   name: 'NewBb',
    //   path: '/NewBb',
    //   component: () => import('../components/bb.vue'),
    // },
    // {
    //   meta: {
    //     title: "请假报备日历"
    //   },
    //   name: 'NewBbView',
    //   path: '/NewBbView',
    //   component: () => import('../components/bbview.vue'),
    // },
    // {
    //   meta: {
    //     title: "扫码"
    //   },
    //   name: 'ScanIndex',
    //   path: '/ScanIndex',
    //   component: () => import('../components/ScanIndex.vue'),
    // }
  ]
});
router.afterEach((to) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else {
    document.title = 'SUNSONS';
  }
});

// 输出router
export default router;